import { Slot } from "../slot";

export class ChargingEstimate {
    slot: Slot
    cost: number

    constructor(slot: Slot, cost: number) {
        this.slot = slot
        this.cost = cost
    }
}